<script lang="ts">
    import Credits from '~/components/jet/info/Credits.svelte';
    import { infoGrouping } from './config';
    import type {
        QueueItemMetadata,
        ActionModel,
        CompoundAction,
    } from '~/jet/models';
    import { getI18n } from '~/stores/i18n';
    import { makeCompoundAction } from '@jet-app/music-classical/action-model';
    import { makeCloseFullScreenPlayerAction } from '@jet-app/music-classical/action-model/CloseFullScreenPlayerAction';

    export let item: QueueItemMetadata | null;
    export let isSidebarView: boolean = false;
    const i18n = getI18n();

    $: groupedData = infoGrouping.reduce((acc, groupItem) => {
        if (item[groupItem.data]) {
            if (groupItem.type === 'cell') {
                acc.push({
                    title:
                        item[groupItem.titleData] || $i18n.t(groupItem.title),
                    subtitle: item[groupItem.data],
                    segue: updateSegue(item[groupItem.segue]),
                    type: 'info',
                });
            }

            // Groups of data, like artists or credits, should already be in
            // the expected data shape, so just push into the main collection.
            if (groupItem.type === 'grouping') {
                item[groupItem.data]?.forEach((subitem) => {
                    acc.push({
                        ...subitem,
                        segue: updateSegue(subitem.segue),
                    });
                });
            }
        }

        return acc;
    }, []);

    // Updates the segue property on a grouped item to be a compound action that
    // closes the full screen player when clicked.  Only updates the segue if
    // we are in a full screen player view.
    function updateSegue(
        segue?: ActionModel,
    ): ActionModel | CompoundAction | undefined {
        if (!segue) {
            return;
        }

        if (isSidebarView) {
            return segue;
        }

        return makeCompoundAction({ custom: {}, data: [] }, [
            segue,
            makeCloseFullScreenPlayerAction(),
        ]);
    }
</script>

<Credits infoItems={groupedData} />

<Credits infoItems={item.credits} />
